exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* COLORS - Approved by the UX CoE */\n.vdl-footer {\n  background: #e4e4e4;\n  border-top: 1px solid #bbb;\n  padding: 10px 15px; }\n  .vdl-footer > ul {\n    display: flex;\n    list-style: none;\n    align-items: center;\n    margin: 0;\n    padding: 0; }\n    .vdl-footer > ul > li {\n      margin-right: 25px;\n      font-size: 12px; }\n      .vdl-footer > ul > li.copyright {\n        margin-right: 0;\n        margin-left: auto; }\n\n@media (max-width: 980px) {\n  .vdl-footer {\n    padding: 0 15px; }\n    .vdl-footer > ul {\n      display: block; }\n      .vdl-footer > ul > li {\n        margin-right: 0;\n        text-align: center;\n        border-bottom: 1px solid #bbb; }\n        .vdl-footer > ul > li > a, .vdl-footer > ul > li.copyright {\n          padding: 15px;\n          display: block; }\n        .vdl-footer > ul > li.copyright {\n          border-bottom: 0; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js??ref--3-2!./src/components/footer/footer.scss
// module id = 634
// module chunks = 0 1 2 3